import { c as _c } from "react/compiler-runtime";
// Default OG shell variant. Navy halftone raster + bottom blue wash, split
// header chrome (logo left, `morfi.markets` top-right).

import type { ReactNode } from 'react';
import { OG_DIMENSIONS, OG_TOKENS } from '../../tokens';
import { OgCelebrationOverlay } from '../chrome/og-celebration-overlay';
import { OgDemoModeBadge } from '../chrome/og-demo-mode-badge';
import { OgHeaderChrome } from '../chrome/og-header-chrome';
import { OgShellBackground } from '../chrome/og-shell-background';
import { OgShellSlot } from '../chrome/og-shell-slot';
import { SHELL_METRICS } from '../shell-tokens';
interface VariantProps {
  children: ReactNode;
  eyebrow?: string | null;
  demoMode?: boolean;
}
export function ShellDefault(props) {
  const $ = _c(13);
  const m = SHELL_METRICS.default;
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: OG_DIMENSIONS.width,
      height: OG_DIMENSIONS.height,
      position: "relative",
      display: "flex",
      flexDirection: "column",
      padding: m.inset,
      gap: m.contentGap,
      color: OG_TOKENS.gray50,
      fontFamily: "Geist, var(--font-geist-sans), system-ui, sans-serif",
      overflow: "hidden"
    };
    t1 = <OgShellBackground variant="default" />;
    t2 = <OgCelebrationOverlay />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  const t3 = props.eyebrow ?? m.eyebrow;
  let t4;
  if ($[3] !== t3) {
    t4 = <OgHeaderChrome layout={m.headerLayout} logoSize={m.logoSize} eyebrow={t3} />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== props.children) {
    t5 = <OgShellSlot padding={m.slotPadding} contentJustify={m.slotContentJustify}>{props.children}</OgShellSlot>;
    $[5] = props.children;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== props.demoMode) {
    t6 = props.demoMode === true && <OgDemoModeBadge />;
    $[7] = props.demoMode;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = <div style={t0}>{t1}{t2}{t4}{t5}{t6}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}